<template>
  <div>
    <div class="newInfo">
      <div class="newInfo-leftTitle">
        <p class="newInfo-leftTitle-title">中国最具成长性半导体企业评选</p>
        <p class="newInfo-leftTitle-subhead">—2004年度中国最具成长性半导体企业评选结果揭</p>
      </div>
      <div class="newInfo-tightTitle">
        <p class="newInfo-tightTitle-title">—2008—</p>
        <p class="newInfo-tightTitle-subhead">12/14</p>
      </div>
      <div class="newInfo-content">
        <span class="newInfo-content-introduce">
          报讯&nbsp;&nbsp;3月2日，在上海举行的2005年中国半导体市场年会上，2004年度中国最具成长性半导体企业的评选结果揭晓。为表彰国内
          集成电路企业，特别是各中小企业在2004年所取得的成绩.树立行业发展的典型，中国半导体行业协会，中国电子信息产业发展研
          究院。赛迪顾问股份有限公司评选出其中具有代表性的企业作为“2004年度中国最具成长性半导体企业”。
        </span>
        <br/>
        <img class="newInfo-content-leftImg" src="../../assets/images/news/tu2.png"/>
        <img class="newInfo-content-rightImg" src="../../assets/images/news/tu2.png"/>
        <br/>
        <span class="newInfo-content-introduce">
          2004年度中国最具成长性集成电路设计企业(排名不分先后)：北京中电华大电子设计有限责任公司、北京海尔集成电路设计有限公
          司、北京华虹集成电路设计有限责任公司，北京清华同方微电子有限公司、瑞萨集成电路设计(北京)有限公司。展讯通信(上海)有限
          公司、埃派克森微电子(上海)有限公司、中颖电子(上海)有限公司、上海英联电子科技有限公司、深圳市中兴集成电路设计有限责任
          公司。
        </span>
        <img class="newInfo-content-leftImg" src="../../assets/images/news/tu2.png"/>
        <img class="newInfo-content-rightImg" src="../../assets/images/news/tu2.png"/>
        <br/>
        <span class="newInfo-content-introduce">
          2004年度中国最具成长性封装测试企业(排名不分先后)；威宇科技测试封装(上海)有限公司、快捷半导体(苏州)有限公司、捷敏电子
          (上海)有限公司、天水华天微电子有限公司、东芝半导体(无锡)有限公司、无锡华润安盛科技有限公司、上海纪元微科电子有限公司，
          广东省粤晶高科股份有限公司，无锡红光微电子有限公司。
        </span>
        <br/>
        <span class="newInfo-content-end">——  THE END  ——</span>
      </div>
      <!--      分割线     -->
      <div style="border: 2px dotted #bddaf8;margin: 10px 0;"></div>
      <div class="newInfo-recommend">
        <div>
          <span style="display:block;margin-top:20px;margin-left:20px;text-align:center;width:120px;height: 100%;line-height:40px;background: #4990e2;">相关推荐</span>
          <!--    小三角   -->
          <span style="display:block;margin-left: 30px;width: 0;height: 0;border-width: 10px;border-style: solid;border-color:#4990e2 transparent transparent transparent;"></span>
        </div>

        <div class="newInfo-recommend-info">
          <div style="width: 118px;float: left">
            <img src="../../assets/images/news/xinpian1.png"/>
          </div>
          <div  style="width: calc(100% - 118px);float: left;height: 100%;background: #EFF5FF">
            <span style="font-size: 14px;font-weight: 600;color: #333333">基于SH366000的智能电池 ...</span>
            <span style="font-size: 14px;color: #999999">A）JET5 增加了一个输入管，用於显示晶片的烧写介面...</span>
          </div>
        </div>

        <div class="newInfo-recommend-info">
          <div style="width: 118px;float: left">
            <img src="../../assets/images/news/xinpian1.png"/>
          </div>
          <div  style="width: calc(100% - 118px);float: left;height: 100%;background: #EFF5FF">
            <span style="font-size: 14px;font-weight: 600;color: #333333">基于SH366000的智能电池 ...</span>
            <span style="font-size: 14px;color: #999999">A）JET5 增加了一个输入管，用於显示晶片的烧写介面...</span>
          </div>
        </div>

        <div class="newInfo-recommend-info">
          <div style="width: 118px;float: left">
            <img src="../../assets/images/news/xinpian1.png"/>
          </div>
          <div  style="width: calc(100% - 118px);float: left;height: 100%;background: #EFF5FF">
            <span style="font-size: 14px;font-weight: 600;color: #333333">基于SH366000的智能电池 ...</span>
            <span style="font-size: 14px;color: #999999">A）JET5 增加了一个输入管，用於显示晶片的烧写介面...</span>
          </div>
        </div>

        <div class="newInfo-recommend-info">
          <div style="width: 118px;float: left">
            <img src="../../assets/images/news/xinpian1.png"/>
          </div>
          <div  style="width: calc(100% - 118px);float: left;height: 100%;background: #EFF5FF">
            <span style="font-size: 14px;font-weight: 600;color: #333333">基于SH366000的智能电池 ...</span>
            <span style="font-size: 14px;color: #999999">A）JET5 增加了一个输入管，用於显示晶片的烧写介面...</span>
          </div>
        </div>

        <div class="newInfo-recommend-info">
          <div style="width: 118px;float: left">
            <img src="../../assets/images/news/xinpian1.png"/>
          </div>
          <div  style="width: calc(100% - 118px);float: left;height: 100%;background: #EFF5FF">
            <span style="font-size: 14px;font-weight: 600;color: #333333">基于SH366000的智能电池 ...</span>
            <span style="font-size: 14px;color: #999999">A）JET5 增加了一个输入管，用於显示晶片的烧写介面...</span>
          </div>
        </div>

        <div class="newInfo-recommend-info">
          <div style="width: 118px;float: left">
            <img src="../../assets/images/news/xinpian1.png"/>
          </div>
          <div  style="width: calc(100% - 118px);float: left;height: 100%;background: #EFF5FF">
            <span style="font-size: 14px;font-weight: 600;color: #333333">基于SH366000的智能电池 ...</span>
            <span style="font-size: 14px;color: #999999">A）JET5 增加了一个输入管，用於显示晶片的烧写介面...</span>
          </div>
        </div>

        <div style="clear:both"></div>
      </div>
    </div>
  </div>
</template>

<script>
    export default {
        name: "newInfo"
    }
</script>

<style >
  .newInfo{ width: 70%;margin: 0 auto}

  .newInfo-leftTitle{margin-bottom:40px;width: 80%;height:100px;float: left;}
  .newInfo-leftTitle-title{margin:10px;font-size: 24px;color: #333333;line-height: 30px;}
  .newInfo-leftTitle-subhead{margin:10px;font-size: 18px;color: #999999;line-height: 30px;}
  .newInfo-tightTitle{margin-bottom:40px;width: 20%;height:100px;text-align:right;float: right;}
  .newInfo-tightTitle-title{margin: 0 10px;font-size: 14px;color: #999999;line-height: 20px;}
  .newInfo-tightTitle-subhead{margin: 0 10px;font-size: 24px;color: #999999;line-height: 30px;}
  .newInfo-content-leftImg{margin-top: 20px;margin-bottom: 20px;width: 48%;height:300px;margin-right: 2%; }
  .newInfo-content-rightImg{margin-top: 20px;margin-bottom: 20px;width: 48%;height:300px;}
  .newInfo-content-introduce{display: block;font-size: 14px;color: #999999}
  .newInfo-content-end{display: block;font-size: 20px;color: #999999;text-align: center;margin: 30px 0;}
  .newInfo-recommend{ min-height: 550px; }
  .newInfo-recommend-info{ width: 45%;float: left;height: 120px;margin: 20px 20px;}
  .newInfo-recommend-info div span{ margin: 10px 20px;display: block;}
</style>



// WEBPACK FOOTER //
// src/pages/news/newInfo.vue